module.exports = __webpack_public_path__ + "img/conf.1c5efc83.png";